import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import { useDidUpdate } from 'bdvp-common/src/hooks';
import { Tracking } from 'bdvp-tracking';

import Form from './Form';
import Error from './Error';
import Loading from './Loading';
import Success from './Success';

const ViewState = {
    FORM: 'FORM',
    LOADING: 'LOADING',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
};

const FormController = ({
    dictionary,
    reel,
    lastModalNode,
    validateReel,
    createReel,
    createReelLoading,
    createReelData,
    createReelError,
    config,
    setModalTitle,
    userId,
    history,
    closeReelCreationModal,
}) => {

    const [
        viewState,
        setViewState,
    ] = useState(ViewState.FORM);

    const [
        formState,
        setFormState,
    ] = useState({
        thumbnailUrl: _get(reel, 'reelClips[0].thumbnailUrl', ''),
        reelTitle: '',
        error: '',
    });

    useEffect(() => {

        setModalTitle(_get(dictionary, 'create_your_reel', 'Create Your Reel'));

    }, [
        setModalTitle,
        dictionary,
    ]);

    useDidUpdate(() => {

        if (createReelLoading) {

            return setViewState(ViewState.LOADING);

        }

        if (
            createReelError
            || (createReelData && createReelData.addReel && !createReelData.addReel.videoUrl)
        ) {

            return setViewState(ViewState.ERROR);

        }

        if (createReelData) {

            if (createReelData?.addReel?.reelTitle) {

                setModalTitle(createReelData.addReel.reelTitle);

            }
            Tracking.trackReelCreated();
            return setViewState(ViewState.SUCCESS);

        }

    }, [
        createReelLoading,
        createReelData,
        createReelError,
    ]);

    if (viewState === ViewState.FORM) {

        return (
            <Form
                reel={reel}
                dictionary={dictionary}
                validateReel={validateReel}
                createReel={createReel}
                formState={formState}
                setFormState={setFormState}
                lastModalNode={lastModalNode}
            />
        );

    }

    if (viewState === ViewState.LOADING) {

        return (
            <Loading
                dictionary={dictionary}
                lastModalNode={lastModalNode}
            />
        );

    }

    if (viewState === ViewState.ERROR) {

        return (
            <Error
                dictionary={dictionary}
                onClick={() => setViewState(ViewState.FORM)}
                lastModalNode={lastModalNode}
            />);

    }

    if (viewState === ViewState.SUCCESS) {

        return (
            <Success
                dictionary={dictionary}
                playerConfig={_get(config, 'player')}
                mediaPlayback={_get(createReelData, 'addReel.mediaPlayback', {})}
                lastModalNode={lastModalNode}
                userId={userId}
                history={history}
                closeReelCreationModal={closeReelCreationModal}
            />
        );

    }

    return null;

};

FormController.propTypes = {
    dictionary: PropTypes.object.isRequired,
    reel: PropTypes.object.isRequired,
    lastModalNode: PropTypes.object.isRequired,
    validateReel: PropTypes.func.isRequired,
    createReel: PropTypes.func.isRequired,
    config: PropTypes.object.isRequired,
    createReelLoading: PropTypes.bool,
    createReelData: PropTypes.object,
    createReelError: PropTypes.object,
    setModalTitle: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    history: PropTypes.shape().isRequired,
    closeReelCreationModal: PropTypes.func.isRequired,
};

FormController.defaultProps = {
    createReelLoading: undefined,
    createReelData: undefined,
    createReelError: undefined,
};

export default FormController;
